var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.355 23.884c0-1.135.817-2.065 1.85-2.065 1.035 0 1.87.93 1.851 2.065 0 1.134-.816 2.064-1.85 2.064-1.016 0-1.85-.93-1.85-2.064zm6.622 0c0-1.135.817-2.065 1.851-2.065s1.85.93 1.85 2.065c0 1.134-.816 2.064-1.85 2.064-1.016 0-1.85-.93-1.85-2.064z",
    fill: "#7289DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.749 6.335H36.25c2.067 0 3.749 1.662 3.749 3.722v32.407l-3.931-3.432-2.213-2.023-2.34-2.15.969 3.342H11.749C9.682 38.201 8 36.54 8 34.48V10.057c0-2.06 1.682-3.722 3.749-3.722zm16.237 22.13a77.62 77.62 0 001.207 1.463c4.041-.127 5.595-2.746 5.595-2.746 0-5.817-2.633-10.532-2.633-10.532-2.633-1.95-5.138-1.896-5.138-1.896l-.256.289c3.108.939 4.553 2.294 4.553 2.294a15.036 15.036 0 00-5.504-1.734 15.662 15.662 0 00-3.694.036c-.095 0-.177.014-.27.029a5.786 5.786 0 01-.04.007c-.64.054-2.195.289-4.151 1.138-.677.307-1.08.524-1.08.524s1.518-1.427 4.81-2.367l-.183-.216s-2.505-.055-5.138 1.896c0 0-2.633 4.715-2.633 10.532 0 0 1.536 2.62 5.577 2.746 0 0 .676-.813 1.225-1.5-2.322-.686-3.2-2.131-3.2-2.131s.183.126.512.307a.744.744 0 00.155.1 10.776 10.776 0 001.417.66c.75.288 1.646.577 2.688.775 1.372.253 2.981.344 4.736.018.86-.144 1.738-.397 2.652-.776.64-.235 1.353-.578 2.103-1.066 0 0-.915 1.481-3.31 2.15z",
    fill: "#7289DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8f7fc37b79389b33a248b81869270181.svg";
export { ForwardRef as ReactComponent };